import "./assets/js/nav-pills.js";
import "./assets/scss/argon-dashboard.scss";
import "./assets/scss/adrian-mercado-subastas.scss";

export default {
  install() {},
};
